import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import { Box, Flex, Text } from 'core/ui/atoms';
import Loading from 'core/ui/components/Loading';
import { isLoading } from 'core/api/loadingHelpers';

const ProgramDetails = ({ getProgramDetail, programLoading }) => {

  if (isLoading(programLoading, getProgramDetail)) {
    return <Loading />;
  }

  const { bundleReservations, mealType, programBundle, subscriptionActive, programType } = getProgramDetail || {};

  const isSubscription = subscriptionActive !== null;

  if (isEmpty(getProgramDetail)) {
    return null;
  }

  return (
    <ProgramContainer>
      <DetailFlexItem direction='row' justifyContent='space-between'>
        <ItemTitle>Program</ItemTitle>
        <ItemValue>{programType}</ItemValue>
      </DetailFlexItem>
      {isSubscription &&
        <DetailFlexItem direction='row' justifyContent='space-between'>
          <ItemTitle>Program Schedule</ItemTitle>
          <ItemValue>Subscription</ItemValue>
        </DetailFlexItem>
      }
      {!isSubscription &&
        <DetailFlexItem direction='row' justifyContent='space-between'>
          <ItemTitle>Program Schedule</ItemTitle>
          <ItemValue>One-Time Program</ItemValue>
        </DetailFlexItem>
      }
      {isSubscription &&
        <DetailFlexItem direction='row' justifyContent='space-between'>
          <ItemTitle>Subscription Status</ItemTitle>
          <ItemValue>{subscriptionActive ? 'Active' : 'Inactive'}</ItemValue>
        </DetailFlexItem>
      }
      <DetailFlexItem direction='row' justifyContent='space-between' alignItems='flex-start'>
        <ItemTitle>Meals</ItemTitle>
        <MealTypeText>{mealType}</MealTypeText>
      </DetailFlexItem>
      <DetailFlexItem direction='row' justifyContent='space-between'>
        <ItemTitle>Meal Portion Size</ItemTitle>
        <ItemValue>{programBundle?.size?.name}</ItemValue>
      </DetailFlexItem>
      <DetailFlexItem direction='row' justifyContent='space-between'>
        <ItemTitle>Days of food (per week)</ItemTitle>
        <ItemValue>{programBundle?.schedule?.daysOfWeek?.length}</ItemValue>
      </DetailFlexItem>
      <DetailFlexItem direction='row' justifyContent='space-between'>
        <ItemTitle>Diet</ItemTitle>
        <ItemValue>{programBundle?.prepaidProgram?.name}</ItemValue>
      </DetailFlexItem>
      {subscriptionActive === null &&
        <Flex direction='row' justifyContent='space-between'>
          <ItemTitle>Program Length</ItemTitle>
          <ItemValue>{bundleReservations?.length}</ItemValue>
        </Flex>
      }
    </ProgramContainer>
  );
};

ProgramDetails.propTypes = {
  getProgramDetail: PropTypes.object,
  programLoading: PropTypes.bool,
  programError: PropTypes.object,
};

const MealTypeText = styled(Text)`
  max-width: 60%;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.3;
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  color: ${(p) => p.theme.colors.primaryV2};
  text-align: right;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
`;

const ProgramContainer = styled(Box)`
  border-radius: 8px;
  background: rgba(197, 209, 192, 0.24);
  padding-left: 12px;
  padding-right: 12px;
`;

const DetailFlexItem = styled(Flex)`
  min-height: 40px;
  &:not(:last-child) {
    border-bottom: 0.5px solid ${(p) => p.theme.colors.primaryV2};
  }
`;

const ItemTitle = styled(Text)`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.3;
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  color: ${(p) => p.theme.colors.primaryV2};
  flex-shrink: 0;
  max-width: 50%;
`;

const ItemValue = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  color: ${(p) => p.theme.colors.primaryV2};
`;

export default ProgramDetails;
